import { render, staticRenderFns } from "./magazines.vue?vue&type=template&id=febcf5c8&"
import script from "./magazines.vue?vue&type=script&lang=js&"
export * from "./magazines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports